// extracted by mini-css-extract-plugin
module.exports = {"container":"AnimateTitle-module--container---4U_o","visible":"AnimateTitle-module--visible--1aBxX"};